import React from 'react';

import Badge from './Badge';

import useCounter from '../hooks/useCounter';

type TBadgeCounter = {
  endpoint?: string;
  badgeKey?: string;
  badgeCount?: number;
  badgeName: string;
};

const BadgeCounter = ({ endpoint, badgeKey, badgeCount = 0, badgeName }: TBadgeCounter) => {
  const counter = useCounter(badgeCount, { badgeKey, badgeName, endpoint });

  if (!counter) {
    return null;
  }

  return (
    <Badge kind="callToAction" badge-name={badgeName}>
      {counter}
    </Badge>
  );
};

export default BadgeCounter;
